import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
const periodicidadOptions = [
  { label: 'Mensual', value: 'mensual' },
  { label: 'Único', value: 'unico' }
];

const Conceptos = () => {
  const [conceptos, setConceptos] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editando, setEditando] = useState(false);

  const [form, setForm] = useState({
    id: null,
    nombre: '',
    periodicidad: '',
    monto_base: ''
  });
  const axiosPrivate = useAxiosPrivate();
  const API = "CEUM/conceptos";
  useEffect(() => {
    fetchConceptos();
  }, []);

  const fetchConceptos = async () => {
    //const res = await fetch('/CEUM/conceptos');
        const res = await axiosPrivate.get(API);

    const data = await res.data;
    setConceptos(data);
  };

  const openNew = () => {
    setForm({ id: null, nombre: '', periodicidad: '', monto_base: '' });
    setEditando(false);
    setVisible(true);
  };

  const editConcepto = (rowData) => {
    setForm(rowData);
    setEditando(true);
    setVisible(true);
  };

  const deleteConcepto = async (rowData) => {
    if (!window.confirm('¿Eliminar concepto?')) return;

    await axiosPrivate.delete(`${API}/${rowData.id}`);

    fetchConceptos();
  };

  const handleChange = (e, field) => {
    setForm({ ...form, [field]: e.target ? e.target.value : e.value });
  };

const saveConcepto = async () => {
  if (!form.nombre || !form.periodicidad || !form.monto_base) {
    alert('Todos los campos son obligatorios');
    return;
  }

  try {
    if (editando) {
      await axiosPrivate.put(`${API}/${form.id}`,
        form
      );
    } else {
      await axiosPrivate.post(
        `${API}`,
        form
      );
    }

    setVisible(false);
    fetchConceptos();

  } catch (error) {
    console.error(error);
  }
};

  const actionBody = (rowData) => (
    <div className="flex gap-2">
      <Button icon="pi pi-pencil" className="p-button-sm" onClick={() => editConcepto(rowData)} />
      <Button icon="pi pi-trash" className="p-button-sm p-button-danger" onClick={() => deleteConcepto(rowData)} />
    </div>
  );

  return (
    <div className="card">
      <div className="flex justify-content-between mb-3">
        <h3>Conceptos de Pago</h3>
        <Button label="Nuevo" icon="pi pi-plus" onClick={openNew} />
      </div>

      <DataTable value={conceptos} paginator rows={10} className="p-datatable-sm">
        <Column field="nombre" header="Nombre" />
        <Column field="periodicidad" header="Periodicidad" />
        <Column field="monto_base" header="Monto" />
        <Column body={actionBody} header="Acciones" />
      </DataTable>

      <Dialog
        header={editando ? 'Editar Concepto' : 'Nuevo Concepto'}
        visible={visible}
        style={{ width: '30vw' }}
        onHide={() => setVisible(false)}
        modal
      >
        <div className="p-fluid">
          <div className="field">
            <label>Nombre</label>
            <InputText value={form.nombre} onChange={(e) => handleChange(e, 'nombre')} />
          </div>

          <div className="field">
            <label>Periodicidad</label>
            <Dropdown
              value={form.periodicidad}
              options={periodicidadOptions}
              onChange={(e) => handleChange(e, 'periodicidad')}
              placeholder="Selecciona"
            />
          </div>

          <div className="field">
            <label>Monto</label>
            <InputText value={form.monto_base} onChange={(e) => handleChange(e, 'monto_base')} />
          </div>
        </div>

        <div className="flex justify-content-end gap-2 mt-3">
          <Button label="Cancelar" className="p-button-text" onClick={() => setVisible(false)} />
          <Button label="Guardar" icon="pi pi-check" onClick={saveConcepto} />
        </div>
      </Dialog>
    </div>
  );
};

export default Conceptos;
